import { objectReduce } from 'fast-loops';
import { hyphenateProperty } from 'css-in-js-utils';
export default function getThemeColors(colors) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return objectReduce(colors, function (themeColors, value, key) {
    if (typeof value === 'string') {
      themeColors[key] = "var(--".concat(prefix).concat(hyphenateProperty(key), ")");
    } else {
      themeColors[key] = getThemeColors(value, prefix + hyphenateProperty(key) + '-');
    }
    return themeColors;
  }, {});
}